import React, { forwardRef } from 'react';
import styled from '@grebban/style-system-react';
import Video from 'Video';

const VideoBackgroundStyle = styled('div')`
    position: relative;
    overflow: hidden;
`;

const StyledVideo = styled(Video)`
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: -1;
    object-fit: cover;
    transform: translate(-50%, -50%);
`;

const VideoBackground = ({ children, src, preload, poster, ...rest }, ref) => (
    <VideoBackgroundStyle {...rest}>
        {children}
        <StyledVideo playsInline autoPlay muted loop ref={ref} src={src} poster={poster} controls={false} preload={preload} />
    </VideoBackgroundStyle>
);

export default forwardRef(VideoBackground);
